<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12 md8 offset-md2 mt-5>
        <v-card>
          <v-card-text class="text-xs-center">
            <h2 v-html="$t('shipmentConfirmationMessage')"></h2>

            <Download :shipment="shipment"></Download>
            <br />
            <v-btn color="primary" outline small @click="goTo('shipments')">{{ $t('back') }}</v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Shipment from '@/client/shipment'

import Download from '@/components/shipments/btns/download'

export default {
  name: 'ShipmentConfirmView',

  props: {},

  data () {
    return {
      shipment: {}
    }
  },

  components: {
    Download
  },

  computed: {
  },

  methods: {
    async fetch () {
      this.shipment = await Shipment.findOne(this.$route.params.id, {
        include: [
          'origin',
          'destination',
          { rate: { service: 'carrier' } },
          'generated_label',
          'user'
        ]
      })
      
      if (this.$store.state.currentUser.id == this.shipment.user.id) this.$store.state.userBalance = this.shipment.user.balance
    }
  },

  watch: {
  },

  async mounted () {
    this.fetch()
  }
}
</script>
